import React from "react";
import { makeStyles } from "@material-ui/core";
import { ChannelBlock, Skeleton } from "../../..";
var useStyles = makeStyles(function (theme) {
  return {
    titleContainer: {
      display: "flex",
      alignItems: "center"
    },
    nameContainer: {
      flex: "1",
      "&:hover": {
        color: theme.palette.primary.main
      }
    },
    iconContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }
  };
});

var ChannelsList = function ChannelsList(props) {
  // console.log("ChannelsList props", props);
  var channels = props.channels,
      users = props.users,
      direct_messages = props.direct_messages,
      translation = props.translation,
      handleClickItem = props.handleClickItem,
      startNewDirectMessage = props.startNewDirectMessage;
  var classes = useStyles(); // console.log("ChannelBlock props", props);

  return /*#__PURE__*/React.createElement("div", {
    className: classes.listContainer
  }, channels.rocket_channels ? /*#__PURE__*/React.createElement(ChannelBlock, {
    data: channels.rocket_channels,
    blockType: "general",
    handleClickItem: handleClickItem,
    translation: translation ? translation.general : null
  }) : /*#__PURE__*/React.createElement(Skeleton, {
    height: 40,
    duration: 1
  }), channels.groups ? /*#__PURE__*/React.createElement(ChannelBlock, {
    data: channels.groups,
    blockType: "group",
    search: true,
    handleClickItem: handleClickItem,
    translation: translation ? translation.groups : null
  }) : /*#__PURE__*/React.createElement(Skeleton, {
    height: 200,
    duration: 1
  }), direct_messages ? /*#__PURE__*/React.createElement(ChannelBlock, {
    data: direct_messages,
    users: users,
    blockType: "direct",
    search: true,
    add: true,
    handleClickItem: handleClickItem,
    translation: translation ? translation.direct_messages : null,
    startNewDirectMessage: startNewDirectMessage
  }) : /*#__PURE__*/React.createElement(Skeleton, {
    height: 200,
    duration: 1
  }));
};

export { ChannelsList };